import WhiteLabel from '../../../filters/WhiteLabel';
import { User } from '../domain/User';
import { UserResponse } from '../type/userResponse';

function onlyUnique<T>(value: T, index: number, self: T[]): boolean {
  return self.indexOf(value) === index;
}

export function transformSessionUser(response: UserResponse, redirectURL?: string): User {
  const perms: string[] = [];

  if (response.roles) {
    response.roles.forEach(role => {
      role.permissions?.forEach(perm => {
        perms.push(perm.access);
      });
    });
  }

  const siteShortCode = WhiteLabel.catalog?.shortCode || 'MG';
  const isAuthor = response.catalogs?.some(catalog => catalog.shortCode === siteShortCode) ?? false;

  return {
    userId: response.userId,
    displayName: response.displayName,
    firstName: response.firstName,
    lastName: response.lastName,
    logInEmail: response.email,
    lastSelectedAccount: response.lastSelectedAccount,
    accountIds: response.accountIds,
    catalogs: response.catalogs as User['catalogs'],
    permissions: perms.filter(onlyUnique),
    redirectURL: redirectURL ?? response.redirectURL,
    impersonating: response.impersonating,
    impersonatingWas: response.impersonatingWas,
    isAuthor,
  };
}
